import './socialMedia.css';
import instagram from '../../assets/instagram.webp';
import linkedIn from '../../assets/linkedIn.webp';

const SocialMedia = () => {
  return (
    <div className='socialMedia'>
        <h4>Auf dem Laufenden bleiben zum Mental-Media-Score</h4>
        <div className="socialMediaContent">
            
            <div className="social-icon">

              <h6>Folgt uns auf Social-Media</h6>
              <div className="socialNetz">
                  <a href="https://www.instagram.com/mentalmediascore"><img src={instagram} alt="" /></a>
                  <a href="https://www.linkedin.com/company/mental-media-score"><img src={linkedIn} alt="" /></a>
              </div>
            </div>
            <div className="newsletter">
              <div className="newsletterContent">
                <h6>Abonniert unseren Newsletter </h6>
                <p>Du willst auf dem Laufenden bleiben und die neusten Entwicklungen zum Mental-Media-Score als erstes erfahren? Trag dich ein - für Impulse, Hintergründe und Tests:</p>
                <a href="https://steady.page/de/funkenflug-mit-eva-list/newsletter/sign_up">Newsletter</a>
              </div>
            </div>
        </div>
    </div>
  )
}

export default SocialMedia